import React from 'react';

// Styles & Assets
import styles from './DialogDeleteZone.module.css';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import useHttp from '../../../hooks/useHttp';

// Components
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

// Interfaces
import { Zone } from '../../../interfaces/Zone';

// Language
import { useTranslation } from 'react-i18next';

const DialogDeleteZoneBed: React.FC<{
    showModal: React.Dispatch<React.SetStateAction<boolean>>,
    zoneID: Zone['id'] | undefined
    callback: (zoneID: Zone['id']) => void
}> = ({ showModal, zoneID, callback }) => {

    const { t } = useTranslation();

    const { sendRequest: deleteZoneBed } = useHttp();

    const handleConfirm = () => {

        if (zoneID) deleteZoneBed({
            url: getEnvironmentApiUrl() + 'zone/' + zoneID, method: 'DELETE',
        }, () => callback(zoneID));

        showModal(false);
    };

    return (
        <div className={`dialog ${styles.dialog}`}>
            <h1 className='dialogTitle'>{t('sure_delete_zone')}</h1>
            <CancelConfirmButtons
                onCancel={() => showModal(false)}
                onConfirm={handleConfirm}
            />
        </div>
    );
};

export default DialogDeleteZoneBed;